const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

function extractJsonFromArray(text) {
    if (!text) return
    //if nova is used

    //if anthropic model is used do this 
    // Regular expression to find a block starting with ```json and ending with ```
    // The 's' flag allows '.' to match newlines.
    const regex = /```json\s*(\[.*?\])\s*```/s;
    const match = text.match(regex);

    if (match && match[1]) {
        const jsonString = match[1];
        try {
            const parsedJson = JSON.parse(jsonString);
            // Ensure the parsed result is an array as expected from the prompt's example.
            if (Array.isArray(parsedJson)) {
                //  console.log("Successfully extracted and parsed JSON:");
                return parsedJson;
            } else {
                //     console.error("Error: Extracted JSON is not an array.");
                return null;
            }
        } catch (error) {
            //    console.error("Error parsing JSON:", error.message);
            return null;
        }
    } else {
        console.warn("No JSON block found in the specified format (```json [...] ```).");
        return null;
    }
}

export {
    delay
}